<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter25">
<h1><a id="page_43"></a><a href="#/003toc#ch25">Chicken and Spinach Soup</a></h1>
<p class="noindent">Vibrantly colored spinach gives this beautiful soup its color, while garlic and ginger add to its personality. This soup is terrific as a starter before a meal, but it’s also nice served in mugs for a warm-up after playing in the snow.</p>
<p class="noindent">3 tablespoons vegetable oil</p>
<p class="noindent">2 cloves garlic, minced</p>
<p class="noindent">2 teaspoons freshly grated ginger</p>
<p class="noindent">3 chicken breast halves, skin and bones removed, cut into ½-inch dice (see savvy)</p>
<p class="noindent">¼ cup soy sauce</p>
<p class="noindent">6 cups chicken broth</p>
<p class="noindent">Three 10-ounce packages baby spinach</p>
<p class="noindent">Toasted sesame oil for garnishing</p>
<p class="noindent">Chopped green onions for garnishing</p>
<p class="noindent">heat the oil in a large skillet or wok over medium-high heat. Add the garlic and ginger and sauté until fragrant, about 30 seconds.</p>
<p class="noindent">add the chicken and sauté until the chicken is white on the outside. Add the soy sauce and cook until the soy sauce is almost evaporated.</p>
<p class="noindent">pour some of the chicken broth into the skillet and transfer the mixture to the insert of a 5- to 7-quart slow cooker, scraping any browned bits from the bottom of the skillet. Add the remaining broth and the spinach to the cooker. Cover and cook on low for 4 to 5 hours.</p>
<p class="noindent">serve the soup in bowls garnished with a dot of sesame oil and a few pieces of green onion.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> chicken savvy</p>
<p class="noindent">If you would like to use leftover cooked chicken, toss the chicken with the garlic and ginger, add the soy sauce as directed, and proceed with the recipe.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 031-chapter25.vue?db0356b8